import { CommonModule, DecimalPipe, I18nPluralPipe, NgOptimizedImage } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';

import { DetailKachelComponent } from './components/detail/details/detail-kachel/detail-kachel.component';
import { DetailsComponent } from './components/detail/details/details.component';
import { DetailHeaderComponent } from './components/detail/header/detail-header.component';
import { KompaktAnsichtComponent } from './components/suchergebnis/ansichten/kompakt-ansicht/kompakt-ansicht.component';
import { SuchergebnisComponent } from './components/suchergebnis/suchergebnis.component';

import { DetailComponent } from './pages/detail/detail.component';
import { SucheComponent } from './pages/suche/suche.component';

import { CookieService } from 'ngx-cookie-service';
import { AngebotListComponent } from './components/angebot-list/angebot-list.component';
import { AngebotTermineComponent } from './components/angebot-termine/angebot-termine.component';
import { BreadcrumbComponent } from './components/breadcrumb/breadcrumb.component';
import { DauerAnzeigeComponent } from './components/dauer-anzeige/dauer-anzeige.component';
import { KontaktAvatarComponent } from './components/detail/details/tab-anbieter/kontakt-slider-kachel/kontakt-avatar/kontakt-avatar.component';
import { KontaktSliderKachelComponent } from './components/detail/details/tab-anbieter/kontakt-slider-kachel/kontakt-slider-kachel.component';
import { TabAnbieterComponent } from './components/detail/details/tab-anbieter/tab-anbieter.component';
import { TabDatenFaktenComponent } from './components/detail/details/tab-daten-fakten/tab-daten-fakten.component';
import { TabInformationenComponent } from './components/detail/details/tab-informationen/tab-informationen.component';
import { FavoriteToggleComponent } from './components/detail/favorite-toggle/favorite-toggle.component';
import { DropdownComponent } from './components/dropdown/dropdown.component';
import { FeedbackComponent } from './components/feedback/feedback.component';
import { GeoisMapComponent } from './components/geois-map/geois-map.component';
import { PaginierungDplComponent } from './components/paginierung/paginierung-dpl/paginierung-dpl.component';
import { ResponsiveCollapseComponent } from './components/responsive-collapse/responsive-collapse.component';
import { ResponsiveContextInfoHeaderComponent } from './components/responsive-context-info-header/responsive-context-info-header.component';
import { MobileShowFilterButtonComponent } from './components/suchergebnis/mobile-show-filter-button/mobile-show-filter-button.component';
import { RequiredInputsStateComponent } from './components/suchergebnis/required-inputs-state/required-inputs-state.component';
import { SuchergebnisEmptyStateComponent } from './components/suchergebnis/suchergebnis-empty-state/suchergebnis-empty-state.component';
import { SuchergebnisHitsCardComponent } from './components/suchergebnis/suchergebnis-hits-card/suchergebnis-hits-card.component';
import { provideLoadingInterceptor } from './interceptors/loading/loading.interceptor';
import { provideXapikeyInterceptor } from './interceptors/xapikey/xapikey.interceptor';

import { NoReferrerDirective, ScrollToAndFocusDirective } from './shared/directives';
import { FocusableIfVisibleDirective } from './shared/directives/focusable-if-visible.directive';
import { TooltipDirective } from './shared/directives/tooltip/tooltip.directive';

import { FilterModule, ModalPopupComponent } from './components';
import { AngebotListItemComponent } from './components/angebot-list-item/angebot-list-item.component';
import { BildungsbereichAendernCardComponent } from './components/bildungsbereich-aendern-card/bildungsbereich-aendern-card.component';
import { BerufeEmptyStateComponent } from './components/suchergebnis/berufe-empty-state/berufe-empty-state.component';
import { BefragungBannerComponent } from './components/befragung-banner/befragung-banner.component';

@NgModule({
  imports: [
    CommonModule,
    NgOptimizedImage,
    FormsModule,
    RouterModule,
    AngebotTermineComponent,
    ScrollToAndFocusDirective,
    DropdownComponent,
    GeoisMapComponent,
    TooltipDirective,
    PaginierungDplComponent,
    FilterModule,
    ResponsiveContextInfoHeaderComponent,
    DauerAnzeigeComponent,
    ResponsiveCollapseComponent,
    BreadcrumbComponent,
    SuchergebnisHitsCardComponent,
    FeedbackComponent,
    FavoriteToggleComponent,
    FocusableIfVisibleDirective,
    AngebotListItemComponent,
    FocusableIfVisibleDirective,
    BildungsbereichAendernCardComponent,
    ModalPopupComponent,
    SucheComponent,
    SuchergebnisComponent,
    MobileShowFilterButtonComponent,
    DetailComponent,
    DetailsComponent,
    DetailHeaderComponent,
    KompaktAnsichtComponent,
    DetailKachelComponent,
    SuchergebnisEmptyStateComponent,
    BerufeEmptyStateComponent,
    NoReferrerDirective,
    AngebotListComponent,
    RequiredInputsStateComponent,
    TabAnbieterComponent,
    TabInformationenComponent,
    TabDatenFaktenComponent,
    KontaktSliderKachelComponent,
    KontaktAvatarComponent,
    BefragungBannerComponent
  ],
  providers: [
    { provide: CookieService },
    { provide: DecimalPipe },
    { provide: I18nPluralPipe },
    provideLoadingInterceptor(),
    provideXapikeyInterceptor()
  ],
  exports: [SucheComponent, DetailComponent, NoReferrerDirective]
})
export class SucheLibModule {}
